import React, {Component} from 'react'
import './style.css'

class MessageList extends Component {


    componentDidMount() {

        this.div.scrollTo(99999999, 999999999)
    }


    componentDidUpdate() {
        this.div.scrollTo(99999999, 999999999)
    }


    render() {
        return (
            <div className='nrt-ead-forum-message-list' ref={div => this.div = div}>
                {this.props.children}

            </div>
        )
    }

}

MessageList.propTypes = {}

MessageList.defaultProps = {}

export default MessageList



// WEBPACK FOOTER //
// ./src/components/_ead/ForumMessages/_components/MessageList/index.js